import { Abstrap } from '..';

const { propTypes } = Abstrap;

const defaultProps = { ...Abstrap.defaultProps, componentClass: 'div' };

class EmptyState extends Abstrap {

    getClassNameSchema() {
        const {
            className,
        } = this.props;
        return [
            'c-empty-state',
            className,
        ];
    }

}

EmptyState.propTypes = propTypes;

EmptyState.defaultProps = defaultProps;

export default EmptyState;
